<div class="slideshow-main" data-cy="organizer-slideshow-container">
  <div class="slideshow-top-controls" data-cy="organizer-slideshow-top-controls">
    <div style="flex: 1;"></div>
    <div style="flex-basis: fit-content; color: white; padding-top: 6px; padding-right: 12px; display: flex;" data-cy="organizer-slideshow-options">
      <mat-checkbox *ngIf="isImage" style="margin-right: 18px; margin-top: 6px;" [(ngModel)]="isPanEnabled" (change)="onPanOptionChange($event)" data-cy="organizer-slideshow-pan-checkbox">Pan enabled</mat-checkbox>
      <mat-checkbox *ngIf="isImage" style="margin-right: 18px; margin-top: 6px;" [(ngModel)]="isFitToScreen" (change)="onFitToScreenOptionChange($event)" data-cy="organizer-slideshow-fit-screen-checkbox">Fit to screen</mat-checkbox>
      <button *ngIf="isPdf" style="margin-top: 1px; margin-right: 10px;" (click)="onPrint()" class="tdo-button tdo-save" data-cy="organizer-slideshow-print-button">Print</button>
      <button *ngIf="isPdf" style="margin-top: 1px; margin-right: 10px;" (click)="onDownload()" class="tdo-button tdo-save" data-cy="organizer-slideshow-download-button">Download</button>
      <button style="margin-top: 1px;" (click)="onClose()" class="tdo-button warn" data-cy="organizer-slideshow-close-button">Close</button>
    </div>
  </div>
  <div #dragArea class="slideshow-content" style="background-color: black;" data-cy="organizer-slideshow-content">
    <ng-container *ngIf="isImage">
      <pan-zoom *ngIf="!isChanging" [config]="panZoomConfig" data-cy="organizer-slideshow-pan-zoom">
          <img *ngIf="isZoomApiReady" [ngClass]="{'show-image': isShowImage, 'hide-image': !isShowImage}" style="width: 100%; height: 100%;" #draggableImage (load)="onImageLoaded()"
            [attr.src]="currentDocumentURL" data-cy="organizer-slideshow-image">
      </pan-zoom>
    </ng-container>
    <ng-container *ngIf="isMovie">
      <video [src]="currentDocumentURL" [autoplay]="true" controls
             style="margin-left: auto; margin-right: auto; display: block; width: fit-content; height: fit-content; position: relative; top: 50%; transform: translateY(-50%);" data-cy="organizer-slideshow-video"></video>
    </ng-container>
    <ng-container *ngIf="isAudio">
      <div style="margin-left: auto; margin-right: auto; display: block; width: fit-content; height: fit-content; position: relative; top: 50%; transform: translateY(-50%);" data-cy="organizer-slideshow-audio-container">
        <audio controls autoplay data-cy="organizer-slideshow-audio">
          <source [src]="currentDocumentURL" />
        </audio>
      </div>
    </ng-container>
    <ng-container *ngIf="isPdf">
      <pdf-viewer #pdfViewer [src]="currentDocumentURL"
                  [render-text]="true"
                  [stick-to-page]="true"
                  [(page)]="pdfPageNum"
                  (after-load-complete)="onAfterPdfLoaded($event)"
                  [external-link-target]="'blank'"
                  [original-size]="false"	
                  [zoom-scale]="'page-fit'"
                  [zoom]="imageScale"
                  style="display: block; width: 100%; height: 100%;" data-cy="organizer-slideshow-pdf-viewer"></pdf-viewer>
    </ng-container>
    <div *ngIf="isPowerPoint || isExcel" style="color: white; height: 100%; width: 100%;" data-cy="organizer-slideshow-office-container">
      <iframe style="width: 100%; height: 100%;" [src]="getSafeUrl()" data-cy="organizer-slideshow-office-frame"></iframe>
    </div>
    <div *ngIf="isXML" style="color: white;" data-cy="organizer-slideshow-xml-container">
      <iframe type="text/plain" data-bind="attr: {src: ({{currentDocumentURL}})}" data-cy="organizer-slideshow-xml-frame"></iframe>
    </div>
    <div *ngIf="isJSON" style="color: white;" data-cy="organizer-slideshow-json-container">

    </div>

<!--    CONTROLS-->
    <div [hidden]="index === 0" style="position: absolute; left: 10px; top: calc((100vh / 2) - 60px); display: flex; color: white;" data-cy="organizer-slideshow-prev-controls">
      <div style="background-color: var(--tdo-primary-accent); border-radius: 50%; margin-right: 6px;" data-cy="organizer-slideshow-first-button-container">
        <button mat-icon-button (click)="onGotoStart()" data-cy="organizer-slideshow-first-button"><mat-icon>first_page</mat-icon></button>
      </div>
      <div style="background-color: var(--tdo-primary-accent); border-radius: 50%;" data-cy="organizer-slideshow-prev-button-container">
        <button mat-icon-button (click)="onPrevious()" data-cy="organizer-slideshow-prev-button"><mat-icon>chevron_left</mat-icon></button>
      </div>
    </div>
    <div [hidden]="index === originals?.length - 1" style="position: absolute; right: 10px; top: calc((100vh / 2) - 60px); display: flex; color: white;" data-cy="organizer-slideshow-next-controls">
      <div style="background-color: var(--tdo-primary-accent); border-radius: 50%; margin-right: 6px;" data-cy="organizer-slideshow-next-button-container">
        <button mat-icon-button (click)="onNext()" data-cy="organizer-slideshow-next-button"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div style="background-color: var(--tdo-primary-accent); border-radius: 50%;" data-cy="organizer-slideshow-last-button-container">
        <button mat-icon-button (click)="onGotoEnd()" data-cy="organizer-slideshow-last-button"><mat-icon>last_page</mat-icon></button>
      </div>
    </div>
  </div>
  <div *ngIf="isPdf" style="flex-basis: 30px;" data-cy="organizer-slideshow-pdf-footer-container">
    <div class="pdf-footer" data-cy="organizer-slideshow-pdf-footer">
      <button [disabled]="pdfPageNum == 1" mat-icon-button (click)="onPreviousPdfPage()" data-cy="organizer-slideshow-pdf-prev-button"><mat-icon>chevron_left</mat-icon></button>
      <div style="margin-top: 7px;" data-cy="organizer-slideshow-pdf-page-info">Page {{pdfPageNum}}</div>
      <button [disabled]="pdfPageNum == totalPdfPages" mat-icon-button (click)="onNextPdfPage()" data-cy="organizer-slideshow-pdf-next-button"><mat-icon>chevron_right</mat-icon></button>
      <button mat-icon-button (click)="pdfZoomOut()" data-cy="organizer-slideshow-pdf-zoom-out-button"><mat-icon>zoom_out</mat-icon></button>
      <button mat-icon-button (click)="pdfZoomReset()" data-cy="organizer-slideshow-pdf-zoom-reset-button"><mat-icon>zoom_out_map</mat-icon></button>
      <button mat-icon-button (click)="pdfZoomIn()" data-cy="organizer-slideshow-pdf-zoom-in-button"><mat-icon>zoom_in</mat-icon></button>
    </div>
  </div>
</div>

